import { WireFunnelType } from 'scenes/common/types';
import { WireLandlordFormData } from 'scenes/landlord/types';
import { LandlordFunnelState } from 'scenes/landlord/flows/types';
import {
  getQuoteNumber,
  getSelectedInsuranceOption,
  isFlybuysMember,
  hasBuildingCoverType,
  getSelectedBuildingExcess,
  hasContentsCoverType,
  getSelectedContentsExcess,
  getCoverType,
} from 'scenes/landlord/selectors';
import { toQuoteNumberWithDashes } from 'scenes/common/helpers/quote';
import { toWireCoverType } from 'scenes/common/api/quote/marshaller/coverage';
import { toProductSubtype } from 'scenes/common/analytics/marshaller/formData';

import { toWirePayment } from './payment';

const toBuildingExcess = (state: LandlordFunnelState): string =>
  hasBuildingCoverType(state)
    ? getSelectedBuildingExcess(state).amount.toString()
    : '';

const toContentsExcess = (state: LandlordFunnelState): string =>
  hasContentsCoverType(state)
    ? getSelectedContentsExcess(state).amount.toString()
    : '';

export const toWireFormData = (
  state: LandlordFunnelState,
  quoteNumber?: string
): WireLandlordFormData => ({
  quoteNumber: toQuoteNumberWithDashes(quoteNumber || getQuoteNumber(state)),
  productType: WireFunnelType.Landlord,
  productSubtype: toProductSubtype(
    WireFunnelType.Landlord,
    toWireCoverType(getCoverType(state))
  ),
  quoteAmountWithExtras:
    getSelectedInsuranceOption(state)?.premium.annualPrice || '',
  flybuysStatus: isFlybuysMember(state),
  buildingExcessAmount: toBuildingExcess(state),
  contentsExcessAmount: toContentsExcess(state),
  payment: toWirePayment(state),
});
